import debug from 'debug';
import Debounce from 'Global/Shared/Components/Debounce/Debounce';
import Swiper from 'swiper/bundle';
import Authentication from 'Minetilbud/Shared/Components/Authentication/Authentication';
import Breakpoints from 'Minetilbud/Shared/Components/Breakpoints/Breakpoints';
import tilbageRenSvg from 'Minetilbud/Shared/Icons/tilbage_ren.svg';
import fremRenSvg from 'Minetilbud/Shared/Icons/frem_ren.svg';
import InView from './in-view';
import Data from '../data/data';
import Templates from './templates';

const log = debug('BoostBanner:Render:ApiItems');
const breakpoints = new Breakpoints();
const data = new Data()
const debounce = new Debounce().debounce;

class ApiItems {
	constructor(element, dom, settings) {
		this.element = element;
		this.dom = dom;
		this.settings = settings;

		this.heroLocation = 'web front page hero';
		this.inspirationLocation = 'web front page inspiration';
		this.user = {};

		this.resizeEvent = this.resizeHandler.bind(this);
		this.resizeHandler = debounce(this.resizeHandler, 250);

		this.isDesktop = breakpoints.MediaBreakpointUp('md');

		this.initialize();
	}

	eventListeners() {
		window.addEventListener('resize', this.resizeEvent, false);
	}

	async getDataset() {
		const dataset = await data.get({ locationId: this.settings.location });

		log('location, dataset', this.settings.location, dataset);

		return dataset;
	}

	async getUser() {
		if (Authentication.isAuthenticated() === false) return;

		const profile = await data.getUserProfile();
		const userProfile = await data.getUserProfile(profile._links.profile.href);

		this.user = userProfile;
		return true;
	}

	async initialize() {
		this.dom.wrapper.innerHTML = '';
		this.dataset = await this.getDataset();
		
		if (this.dataset.bannerLocation === null) {
			log(`ERROR - Banner Location ${this.settings.location} does not exist`);
			return;
		}

		this.location = this.dataset.bannerLocation.locationDisplayName.toLowerCase();

		if (this.dataset.bannerLocation.banners.length === 0) {
			log(`ERROR - Banner Location ${this.settings.location} has no banners`);
			return;
		}

		await this.getUser();
		this.setLocation();
		this.render();
		this.setupFirst();
		this.eventListeners();
		this.initSwiper();
	}

	initSwiper() {
		if (this.swiper) {
			this.swiper.destroy();
		}
		this.swiper = new Swiper(this.element, this.options);
		this.element.classList.remove('is-loading');
		
		const inView = new InView(this.element, this.settings.location, this.swiper, parseInt(this.dataset.settings.bannerRegisterTime));
	}

	render() {
		const templates = new Templates();
		const scale = window.devicePixelRatio;
		const siteWidth = this.element.getBoundingClientRect().width;

		log('user: ', this.user.nejtakplus === undefined ? 'Alle' : this.user.nejtakplus ? 'NejTak+' : 'Online');

		this.dataset.bannerLocation.banners.forEach((banner, index) => {
			if (banner.targetGroup.name.toLowerCase() === 'alle') {
				this.renderBanner(banner, scale, siteWidth, templates);	
			} 

			if (this.user.nejtakplus === undefined) return;
			
			if (banner.targetGroup.name.toLowerCase() === 'online' && this.user.nejtakplus === false) {
				this.renderBanner(banner, scale, siteWidth, templates);	
			} else if (banner.targetGroup.name.toLowerCase() === 'nejtak+' && this.user.nejtakplus === true) {
				this.renderBanner(banner, scale, siteWidth, templates);	
			}
		});
	}

	renderBanner(banner, scale, siteWidth, templates) {
		if (this.location === this.heroLocation) {
			this.dom.wrapper.insertAdjacentHTML('beforeend' , templates.frontPageHero(banner, scale, siteWidth));
		} else if (this.location = this.inspirationLocation) {
			this.dom.wrapper.insertAdjacentHTML('beforeend' , templates.frontPageInspiration(banner, scale, siteWidth));
		}
	}

	resizeHandler() {
		const isDesktop = breakpoints.MediaBreakpointUp('md');

		if (this.isDesktop === isDesktop) return;

		this.isDesktop = isDesktop;

		this.dom.wrapper.innerHTML = '';

		this.render();
		this.setupResize();
		this.initSwiper();
	}

	setLocation() {
		switch(this.location) {
			case this.heroLocation:
				this.element.classList.add('is-front-page-hero');
				break;
			case this.inspirationLocation:
				this.element.classList.add('is-front-page-inspiration');
				break;
		}		

	}

	setupFirst() {
		this.element.classList.add('swiper-container');
		this.dom.wrapper.classList.add('swiper-wrapper');

		[...this.dom.wrapper.children].map(child => {
			child.classList.add('swiper-slide');
		});

		this.options = {
			speed: this.dataset.settings.carrouselSwitchBannerTime,
			loop: this.dataset.settings.carrouselRepeat,
		}

		const slideCount = this.dom.wrapper.children.length;
		if (slideCount < 2) return;

		this.dom.buttonNext.classList.add('o-boost-banner__button-next');
		this.dom.buttonNext.insertAdjacentHTML('beforeend', fremRenSvg);

		this.dom.buttonPrev.classList.add('o-boost-banner__button-prev');
		this.dom.buttonPrev.insertAdjacentHTML('beforeend', tilbageRenSvg);

		this.options = {
			speed: this.dataset.settings.carrouselSwitchBannerTime,
			loop: this.dataset.settings.carrouselRepeat,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
				bulletClass: 'o-boost-banner__bullet',
				bulletActiveClass: 'o-boost-banner__bullet--active'
			},
			navigation: {
				nextEl: '.o-boost-banner__button-next',
				prevEl: '.o-boost-banner__button-prev'
			}
		}

		if (this.dataset.settings.carrouselAutostart === true) {
			this.options = {
				slidesPerView: 1,
				speed: this.dataset.settings.carrouselSwitchBannerTime,
				loop: this.dataset.settings.carrouselRepeat,
				autoplay: {
					delay: this.dataset.settings.carrouselShowNewBannerWaitTime
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
					bulletClass: 'o-boost-banner__bullet',
					bulletActiveClass: 'o-boost-banner__bullet--active'
				},
				navigation: {
					nextEl: '.o-boost-banner__button-next',
					prevEl: '.o-boost-banner__button-prev'
				}
			}
		}
	}

	setupResize() {
		[...this.dom.wrapper.children].map(child => {
			child.classList.add('swiper-slide');
		});
	}
}

export default ApiItems;
 